<template>
    <div class="content p-3">
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="goback()">
                <b-icon icon="arrow-left-square-fill"></b-icon> {{ $route.query.desc }}
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown right>
                                                   
                                                    <template #button-content>
                                                        ພາສາ
    </template>
                            <b-dropdown-item href="#">LA</b-dropdown-item>
                            <b-dropdown-item href="#">EN</b-dropdown-item>
                        </b-nav-item-dropdown>   -->

                <b-nav-item @click="goback()">
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>

        <b-card :header="$t('button.search')">
            <b-row>
                <b-col>
                    <b-form-select v-model="field" :options="findfied" required placeholder="ຄົ້ນຫາຕາມ">
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-input type="text" v-model="find" placeholder="ຕ້ອງການຄົ້ນຫາ" required>
                    </b-form-input>
                </b-col>
                <b-col>
                    <b-button variant="outline-primary" @click="onSearch">
                        <b-icon icon="search"></b-icon> ຄົ້ນຫາ....
                    </b-button>
                    <b-button variant="outline-success" @click="addnew"> {{ $t("button.add") }} </b-button>

                </b-col>
            </b-row>


        </b-card>

        <b-table head-variant="light" :fields="fields" :items="items" class="mt-3 border">
            <!-- A virtual column -->
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>
            <template #cell(action)="data">
               
                <b-button variant="outline-primary" @click="edit(data.item._id)"> {{ $t("button.edit") }}   </b-button>
                <b-button variant="outline-danger" @click="del(data.item._id)"> {{ $t("button.delete") }} </b-button>
            </template>
        </b-table>
        <infinite-loading @infinite="infiniteHandler" spinner="spiral">
            <div slot="spinner">Loading...</div>
            <div slot="no-more">No more data</div>
            <div slot="no-results">No results data</div>
        </infinite-loading>
</div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment'
export default {

    data() {
        return {
            page: 0,
            field: '',
            find: '',
            menuid: this.$route.query.id,
            pkey: "",
            table: "",
            ptable: "",
            fields: [],
            items: [],

            findfied: [],
            user:[]
        }
    },
    components: {
        InfiniteLoading,
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        formatdate(value){
         if (value) {
            return moment(String(value)).format('MM/DD/YYYY hh:mm')
          }
      },
    },

    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        axios
            .get(
                this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find  +'&branch_id='+this.user.branch_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.pkey = response.data.pkey
                this.table = response.data.table

                this.fields = JSON.parse(response.data.fields)
                this.items = response.data.items
                this.fields.forEach((item) => {
                    this.findfied.push({
                        value: item.key,
                        text: item.label
                    })
                })

            })
            .catch((e) => {
                console.log(e);
            });

            axios
            .get(
                this.$store.getters.getBaseUrl + "/getMenuOne/" + this.menuid  +"?level_id="+ this.user.level.level_id
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                console.log(response.data[0])
                this.menu = response.data[0]
             

            })

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        formatdate(value){
         if (value) {
            return moment(String(value)).format('MM/DD/YYYY')
          }
        },
        infiniteHandler($state) {
            this.busy = true;
            setTimeout(() => {

                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/dynamic_table/" + this.menuid +
                        "?offset=" + this.page + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id,
                        {
                            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                        }
                    )
                    .then((response) => {
                        //this.pkey=response.data.pkey
                        if (this.page == 0) {
                            // this.fields = JSON.parse(response.data.fields)

                            // this.fields.forEach((item) => {
                            //     this.findfied.push({
                            //         value: item.key,
                            //         text: item.label
                            //     })
                            // })
                            this.items = response.data.items;
                            this.page++;
                            $state.loaded();
                        } else {

                            if (response.data.items.length != 0) {
                                this.page++;
                                this.items = this.items.concat(response.data.items);
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                            $state.loaded();
                        }
                    });

                this.busy = false;
            }, 200);
        },

        onSearch() {
            axios
                .get(
                    this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&" + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.items = response.data.items;
                    this.page = 0;

                })
                .catch((e) => {
                    console.log(e);
                });
        },
        addnew() {
            this.$router.push("/genform/" + this.$route.query.id);
        },
        edit(id) {
            //  console.log(this.rowSlect[0].doc_code);
            //  const Values = Object.values(this.rowSlect[0]);
            this.$router.push(
                "/genformedit/" +
                this.$route.query.id +
                "/" +
                this.pkey +
                "/" +
                id
            );
        },
        del(code) {

            let params = {
                table: this.table,
                pkey: this.pkey,
                code: code
            }
            this.$bvModal.msgBoxConfirm('ກະລຸນາຢືນຢັນ ທ່ານຕ້ອງການລົບລາຍການນີອອກຈາກລະບົບ.', {
                title: 'Please Confirm',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value == true) {
                        axios.post(this.$store.getters.getBaseUrl + '/del', params,{
                            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                        })
                            .then((res) => {
                                if (res.data.code == 1) {
                                    this.$bvToast.toast(`ລົບລາຍການອອກສຳເລັດແລ້ວ.`, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })

                                    axios
                                        .get(
                                            this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id,{
                                                headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                                            }
                                        )
                                        .then((response) => {
                                            // JSON responses are automatically parsed.
                                            this.pkey = response.data.pkey
                                            this.table = response.data.table
                                            this.fields = JSON.parse(response.data.fields)
                                            this.items = response.data.items
                                            this.fields.forEach((item) => {
                                                this.findfied.push({
                                                    value: item.key,
                                                    text: item.label
                                                })
                                            })

                                        })
                                        .catch((e) => {
                                            console.log(e);
                                        });

                                    this.page = 0

                                } else {
                                    this.$bvToast.toast(res.data.msg, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })



                                }
                                console.log(res.data)
                            })
                            .catch(err => {

                                console.error(err);
                            })
                    }
                    //this.boxTwo = value
                })
                .catch(err => {
                    console.error(err);
                })

        },
        // format(){
        //   return  new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
        // },
    },

}
</script>

<style scoped>
.content {
    margin-top: 10px;
}
</style>